import { useEffect } from 'react';
import { sendToNative } from '../utils/NativeUtil';

const SCENE_WEBVIEW_BG = '#0D0E12';

export const useSceneWebViewBackground = () => {
  useEffect(() => {
    sendToNative(
      JSON.stringify({
        type: 'setWebViewBackgroundColor',
        color: SCENE_WEBVIEW_BG
      })
    );
    return () => {
      sendToNative(
        JSON.stringify({
          type: 'setWebViewBackgroundColor',
          reset: true
        })
      );
    };
  }, []);
};
